/**
 * Labs Configuration
 *
 * Define labs for local development and testing.
 * These labs will be merged with API-returned eligible labs in non-production environments.
 *
 * USAGE:
 * 1. Add your lab to the localLabs array
 * 2. Set enabled: true to activate it
 * 3. Lab will appear in useEnrolledLabs alongside API labs
 * 4. Remove or disable when API is deployed
 */

/**
 * @typedef {Object} LocalLab
 * @property {string} name - Display name (e.g., 'Notifications')
 * @property {string} labPath - Path to lab page (e.g., '/labs/notifications/')
 * @property {string} [replacesPath] - Path to original feature (e.g., '/alerts')
 * @property {string} [labComponent] - Component identifier for programmatic access
 * @property {boolean} [enabled] - Whether this lab is active (default: true)
 */

/**
 * Local labs configuration
 * @type {LocalLab[]}
 */
export const localLabs = []

/**
 * Check if local labs should be loaded
 * Only loads in non-production environments
 */
export const shouldLoadLocalLabs = () => {
  const config = useRuntimeConfig()
  return config.public.env !== 'production'
}
